/**
 * @name setDrawerButton
 * @description ドロワーナビの開閉
 * @param {Object} html html要素
 * @param {Object} DrawerButton ドロワーボタン要素
 * @param {Object} Links アンカーリンク
 */
export function setDrawerButton() {
  let html = document.querySelector('html');
  let DrawerButton = document.querySelector('.drawerButton');
  let Links = document.querySelectorAll('a[data-anchor="true"]');
  if (!DrawerButton) return;

  /**
   * @name navOpen
   * @description ドロワーナビを開く
   */
  const navOpen = () => html.dataset.state = "navOpen";

  /**
   * @name navClose
   * @description ドロワーナビを閉じる
   */
  const navClose = () => html.dataset.state = "";
  
  // ドロワーボタンクリック時
  DrawerButton.addEventListener("click", () => {
    html.dataset.state === "navOpen" ? navClose() : navOpen()
  });

  // アンカーリンククリック時
  Links.forEach((link) => link.addEventListener("click", navClose))
};